export default __webpack_public_path__ + "static/ayvakit-logo-hero-gateway-79691d173476415716cab21cfee4d0b3.png";